import {Button, CardContent, CardMedia, Typography} from '@mui/material';
import React, {Fragment, useCallback} from 'react';

import {ExternalServicesTaggingEnum} from 'main/analytics/gaTagsEnum';
import {makeGetWhoIndicatesLink} from 'main/factories/usecases/private/remote-home/get-who-indicates';
import whoIndicatesImgLg from 'presentation/assets/images/who-indicates-lg.webp';
import whoIndicatesImgSm from 'presentation/assets/images/who-indicates-sm.webp';
import {Loading} from 'presentation/components/Loading/Loading';
import {useGetEndpointUrl} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {AlertModal} from '../AlertModal';
import {StyledCard, StyledCardActions, StyledImageContainer, StyledInfoContainer} from './styles';
import {CardProps} from './types';

const {recommendation} = translations['pt-br'].privateFlow.services;
const {whoIndicatesTitle, whoIndicatesDescription} = translations['pt-br'].privateFlow.perks;
const {learnMore, serverError, notice, serverErrorTitle, tryAgain} = translations['pt-br'].commons;

export function WhoIndicatesCard({$showAsBanner, pathParametric, dataTagId}: CardProps) {
	const {isMobile, isDesktop} = useMediaQueries();
	const {isError, setIsError, getLink, isLoading} = useGetEndpointUrl(recommendation);

	const whoIndicatesImg = !isMobile && !isDesktop ? whoIndicatesImgSm : whoIndicatesImgLg;

	const handleGetWhoIndicatesUrl = useCallback(() => {
		getLink(
			makeGetWhoIndicatesLink,
			false,
			false,
			pathParametric ? {utm_medium: pathParametric} : undefined,
		);
	}, []);

	return (
		<Fragment>
			<StyledCard
				$showAsBanner={$showAsBanner}
				elevation={0}
				data-tag-id={ExternalServicesTaggingEnum.CLICK_CLUBE_DE_VANTAGENS}>
				<StyledImageContainer $showAsBanner={$showAsBanner}>
					<CardMedia
						component="img"
						image={whoIndicatesImg}
						title={whoIndicatesTitle}
						sx={{maxHeight: 180}}
					/>
				</StyledImageContainer>
				<StyledInfoContainer flex={3} $showAsBanner={$showAsBanner}>
					<CardContent sx={{paddingBottom: 1.5}}>
						<Typography variant="alertTitle">{whoIndicatesTitle}</Typography>
						<Typography variant="body2" color="text.secondary" mt={isMobile ? 0.7 : 0}>
							{whoIndicatesDescription}
						</Typography>
					</CardContent>
					<StyledCardActions $showAsBanner={$showAsBanner}>
						<Button
							data-tag-id={dataTagId}
							disabled={isLoading}
							onClick={handleGetWhoIndicatesUrl}
							size="medium"
							variant="contained"
							fullWidth
							endIcon={
								isLoading ? (
									<Loading size={isMobile ? 18 : 20} color="inherit" />
								) : null
							}>
							{learnMore}
						</Button>
					</StyledCardActions>
				</StyledInfoContainer>
			</StyledCard>
			{isError ? (
				<AlertModal
					open={isError}
					onClose={() => setIsError(false)}
					description={serverError}
					title={serverErrorTitle}
					headerTitle={notice}
					variant="info"
					footerContent={
						<Button
							variant="contained"
							size="large"
							fullWidth
							onClick={() => {
								setIsError(false);
								handleGetWhoIndicatesUrl();
							}}>
							{tryAgain}
						</Button>
					}
				/>
			) : null}
		</Fragment>
	);
}
